import Select, { customFilterSelectStyles, defaultMultipleSelectProps, ValueContainer } from "components/shared/select";
import { accessPermitRelationTypes } from "helpers/enums";
import { enumLabel } from "helpers/system";
import React, { useEffect, useState } from "react";
import { selectList } from "sources/books/accessPermits";

export default function AccessPermitsSelect(props) {
    const [loaded, setLoaded] = useState(false);
    const [data, setData] = useState([]);

    useEffect(() => {
        selectList({}).then((res) => {
            const grouped = res.reduce((acc, item) => {
                acc[item.relationType] ??= [];
                acc[item.relationType].push({
                    label: item.name,
                    value: item.id,
                    relationType: item.relationType,
                    option: { label: item.name, value: item.id, relationType: item.relationType },
                });
                return acc;
            }, {});
            setData(
                Object.entries(grouped).map(([key, options]) => ({
                    label: enumLabel(accessPermitRelationTypes, key),
                    options,
                })),
            );
            setLoaded(true);
        });
    }, []);
    if (!loaded) {
        return null;
    }

    const selectProps = {
        ...defaultMultipleSelectProps,
        styles: { ...customFilterSelectStyles },
        components: { ValueContainer },
    };
    return (
        <Select
            {...selectProps}
            isGrouped
            options={data}
            inputProps={{ name: "accessPermitIds" }}
            placeholder="По допускам машин, водителей или прицепов"
            onChange={props.onChange}
            value={props.value}
        />
    );
}
